import React, { Component } from 'react';

import Prism from '../../../prism-plugins-tomorrow'
import $ from "jquery";
import {withParams} from "../../../App";
import {attachCopyTagHandlers} from "../../../utility";
import PageComponent from "../../pageComponent/pageComponent";
class SparkPage extends Component {
  

    state = {
        title: '',
        tags: [],
        html: '',
        nextContent:'',
        relatedContent: [],
        sourceLinks: [],
        algos: [],
        languages: [],
        attributed:[],
        suggestedCourses:[],
        slug: '',
        counter : 0
    };

  slugs = [
      {slug: 'getting-started-with-Apache-Spark',
          source: '/dc/html/spark/getting-started-with-Spark.html',
          title: 'Apache Spark',
          tags: ['Distributed', 'Spark'], sourceLinks: [], languages:['Java'], algos: [] },
      {slug: 'Apache-Spark-scheduling',
          source: '/dc/html/spark/spark-scheduling.html',
          title: 'Apache Spark Scheduling',
          tags: ['Distributed', 'Spark'], sourceLinks: [], languages:['Java'], algos: [] },
      {slug: 'Apache-Spark-state',
          source: '/dc/html/spark/spark-grain-state.html',
          title: 'Apache Spark State',
          tags: ['Distributed', 'Spark'], sourceLinks: [], languages:['Java'], algos: [] },
      {slug: 'Apache-Spark-grains',
          source: '/dc/html/spark/spark-grain.html',
          title: 'Apache Spark Grains',
          tags: ['Distributed', 'Spark', 'Grains'], sourceLinks: [], languages:['Java'], algos: [] },
      {slug: 'Spark-silos-lifecycle',
          source: '/dc/html/spark/spark-silos.html',
          title: 'Apache Spark Silo',
          tags: ['Distributed', 'Spark', 'Silo'], sourceLinks: [], languages:['Java'], algos: [] },
      {slug: 'Apache-Spark-persistence',
          source: '/dc/html/spark/spark-persistence.html',
          title: 'Apache Spark Persistence',
          tags: ['Distributed', 'Spark', 'Persistence'], sourceLinks: [], languages:['Java'], algos: []},
      {slug: 'Apache-Spark-streaming',
          source: '/dc/html/spark/getting-started-with-Spark.html',
          title: 'Apache Spark Streaming',
          tags: ['Distributed', 'Spark', 'Stream'], sourceLinks: [], languages:['Java'], algos: []},
      {slug: 'Apache-Spark-observability',
          source: '/dc/html/spark/spark-observability.html',
          title: 'Apache Spark Observability',
          tags: ['Distributed', 'Spark', 'Observability'], sourceLinks: [], languages:['Java'], algos: [] },
      {slug: 'Apache-Spark-distributed-tracing',
          source: '/dc/html/spark/spark-distributed-tracing.html',
          title: 'Distributed Tracing With Spark',
          tags: ['Distributed', 'Spark', 'Observability'], sourceLinks: [], languages:['Java'], algos: [] },
      {slug: 'apache-spark-concepts', source: '/dc/html/spark/apache-spark-concepts.html', title: 'Apache Spark Concepts', tags: ['Distributed', 'Spark'], sourceLinks: [], languages:['Java'], algos: [] },
      {slug: 'apache-spark-hosting', source: '/dc/html/spark/spark-hosting.html', title: 'Apache Spark Hosting and Deployment', tags: ['Distributed', 'Spark', 'Deployment'], sourceLinks: [], languages:['Java'], algos: [] },
      {slug: 'apache-spark-dashboard', source: '/dc/html/spark/spark-dashboard.html', title: 'Apache Spark Dashboard', tags: ['Distributed', 'Spark', 'Metrics'], sourceLinks: [], languages:['Java'], algos: [] },
      {slug: 'spark-unit-testing', source: '/dc/html/spark/spark-unit-testing.html', title: 'Apache Spark Unit Testing', tags: ['Distributed', 'Spark', 'Test'], sourceLinks: [], languages:['Java'], algos: [] },
      {slug: 'spark-grain-identity', source: '/dc/html/spark/spark-grain-identity.html', title: 'Apache Spark Identity', tags: ['Distributed', 'Spark', 'Grain'], sourceLinks: [], languages:['Java'], algos: [] },
      {slug: 'spark-grain-state', source: '/dc/html/spark/spark-grain-state.html', title: 'Apache Spark State', tags: ['Distributed', 'Spark', 'Persistence'], sourceLinks: [], languages:['Java'], algos: [] },
      {slug: 'Spark-grain-placement', source: '/dc/html/spark/spark-grain-placement.html', title: 'Apache Spark Grain Placement', tags: ['Distributed', 'Spark', 'Placement'], sourceLinks: [], languages:['Java'], algos: [] },
      {slug: 'spark-grain-lifecycle', source: '/dc/html/spark/spark-grain-lifecycle.html', title: 'Apache Spark Grain Lifecycle', tags: ['Distributed', 'Spark', 'Lifecycle'], sourceLinks: [], languages:['Java'], algos: [] },
      {slug: 'spark-grain-versioning', source: '/dc/html/spark/spark-grain-versioning.html', title: 'Apache Spark Grain Versioning', tags: ['Distributed', 'Spark', 'Versioning'], sourceLinks: [], languages:['Java'], algos: [] },
      {slug: 'apache-spark-stateless-worker', source: '/dc/html/spark/spark-stateless-worker.html', title: 'Apache Spark Stateless Worker', tags: ['Distributed', 'Spark'], sourceLinks: [], languages:['Java'], algos: [] },
      {slug: 'apache-spark-reentrant-grain', source: '/dc/html/spark/spark-reentrant-grain.html', title: 'Re-Entrant Grains', tags: ['Distributed', 'Spark'], sourceLinks: [], languages:['Java'], algos: [] },

      {slug: 'getting-started', source: '/dc/html/spark/getting-started-with-Spark.html', title: 'Getting started ', tags: ['Distributed', 'Spark', 'Examples'], sourceLinks: [], languages:['Java'], algos: [] },
      {slug: 'apache-spark-hello-world', source: '/dc/html/spark/hello-world.html', title: 'Hello World', tags: ['Distributed', 'Spark', 'Examples'], sourceLinks: [], languages:['Java'], algos: [] },
      {slug: 'apache-spark-iot-example', source: '/dc/html/spark/iot-example.html', title: 'IOT Example', tags: ['Distributed', 'Spark', 'IOT'], sourceLinks: [], languages:['Java'], algos: [] },
      {slug: 'apache-spark-deployment', source: '/dc/html/spark/spark-deployment.html', title: 'Spark Deployment', tags: ['Distributed', 'Spark', 'Deployment'], sourceLinks: [], languages:['Java'], algos: [] },
      {slug: 'apache-spark-docker-deployment', source: '/dc/html/spark/spark-docker-deployment.html', title: 'Docker Deployment', tags: ['Distributed', 'Spark', 'Deployment'], sourceLinks: [], languages:['Java'], algos: [] },
      {slug: 'Apache-Spark-azure-deployment', source: '/dc/html/spark/spark-azure-deployment.html', title: 'Azure Deployment', tags: ['Distributed', 'Spark', 'Deployment'], sourceLinks: [], languages:['Java'], algos: [] },
  ];


  nextPage = [
      {key: 'getting-started-with-Apache-Spark',
          slug: 'Apache-Spark-concepts',
          title: 'Apache Spark Concepts',
          path: '/distributed-computing/Apache-Spark/concepts/'},
      {key: 'Apache-Spark-concepts',
          slug: 'Apache-Spark-grains',
          title: 'Apache Spark Grains',
          path: '/distributed-computing/Apache-Spark/concepts/'},
      {key: 'Apache-Spark-grains',
          slug: 'Spark-silos-lifecycle',
          title: 'Apache Spark Silos',
          path: '/distributed-computing/Apache-Spark/concepts/'},
      {key: 'Spark-silos-lifecycle',
          slug: 'Apache-Spark-state',
          title: 'Apache Spark State',
          path: '/distributed-computing/Apache-Spark/concepts/'},
      {key: 'Apache-Spark-state',
          slug: 'Apache-Spark-persistence',
          title: 'Apache Spark Persistence',
          path: '/distributed-computing/Apache-Spark/concepts/'},
      {key: 'Apache-Spark-persistence',
          slug: 'Apache-Spark-scheduling',
          title: 'Apache Spark Scheduling',
          path: '/distributed-computing/Apache-Spark/concepts/'},
      {key: 'Apache-Spark-scheduling',
          slug: 'Apache-Spark-hosting',
          title: 'Apache Spark Hosting',
          path: '/distributed-computing/Apache-Spark/concepts/'},
      {key: 'Apache-Spark-hosting',
          slug: 'Apache-Spark-dashboard',
          title: 'Apache Spark Dashboard',
          path: '/distributed-computing/Apache-Spark/concepts/'},
      {key: 'Apache-Spark-dashboard',
          slug: 'Apache-Spark-observability',
          title: 'Apache Spark Observability',
          path: '/distributed-computing/Apache-Spark/concepts/'},
      {key: 'Apache-Spark-observability',
          slug: 'Apache-Spark-distributed-tracing',
          title: 'Distributed Tracing',
          path: '/distributed-computing/Apache-Spark/concepts/'},
      {key: 'Apache-Spark-distributed-tracing',
          slug: 'Spark-unit-testing',
          title: 'Unit Testing',
          path: '/distributed-computing/Apache-Spark/concepts/'},
      {key: 'Spark-unit-testing',
          slug: 'Spark-grain-identity',
          title: 'Grain Identity',
          path: '/distributed-computing/Apache-Spark/concepts/'},
      {key: 'Spark-grain-identity',
          slug: 'Spark-grain-lifecycle',
          title: 'Grain Lifecycle',
          path: '/distributed-computing/Apache-Spark/concepts/'},
      {key: 'Spark-grain-lifecycle',
          slug: 'Spark-grain-placement',
          title: 'Grain Placement',
          path: '/distributed-computing/Apache-Spark/concepts/'},
      {key: 'Spark-grain-placement',
          slug: 'Spark-grain-state',
          title: 'Grain State',
          path: '/distributed-computing/Apache-Spark/concepts/'},
      {key: 'Spark-grain-state',
          slug: 'Apache-Spark-stateless-worker',
          title: 'Stateless Worker Grains',
          path: '/distributed-computing/Apache-Spark/concepts/'},
      {key: 'Apache-Spark-stateless-worker',
          slug: 'Apache-Spark-reentrant-grain',
          title: 'Re-Entrant Grains',
          path: '/distributed-computing/Apache-Spark/concepts/'},
      {key: 'Apache-Spark-reentrant-grains',
          slug: '',
          title: 'Apache Spark',
          path: '/distributed-computing/Apache-Spark/concepts/'},
      {key: 'Apache-Spark-deployment',
          slug: 'Apache-Spark-docker-deployment',
          title: 'Docker Deployment',
          path: '/distributed-computing/Apache-Spark/concepts/'},
      {key: 'Apache-Spark-docker-deployment',
          slug: 'Apache-Spark-azure-deployment',
          title: 'Azure Deployment',
          path: '/distributed-computing/Apache-Spark/concepts/'},
      {key: 'Apache-Spark-azure-deployment',
          slug: '',
          title: 'Apache Spark',
          path: '/distributed-computing/Apache-Spark/concepts/'},

  ]

  relatedPages = [
      { id: 1, key: 'getting-started-with-Apache-Spark', title:'What is Apache Spark', slug:"What is Apache Spark", link: '/distributed-computing/spark/concepts' },
      { id: 2, key: 'how-do-distributed-frameworks-operate', title:'How do distributed-frameworks-operate?', slug:"how-do-distributed-frameworks-operate", link: '/distributed-computing/basics/' },
      { id: 3, key: 'how-do-distributed-frameworks-operate', title:'How do distributed-frameworks-operate?', slug:"how-do-distributed-frameworks-operate", link: '/distributed-computing/basics/' },
      { id: 4, key: 'Apache-Spark-concepts', title:'The Actor Model', slug:"", link: 'https://en.wikipedia.org/wiki/Actor_model' },
      { id: 5, key: 'Apache-Spark-concepts', title:'AKKA Framework', slug:"", link: 'https://akka.io/' },
      { id: 6, key: 'Apache-Spark-grains', title:'Grain Identity', slug:"", link: '/distributed-computing/Apache-Spark/examples/spark-grain-identity' },
      { id: 7, key: 'Apache-Spark-grains', title:'Grain Life Cycle', slug:"", link: '/distributed-computing/Apache-Spark/examples/spark-grain-lifecycle' },
      { id: 8, key: 'Apache-Spark-grains', title:'Grain Placement', slug:"", link: '/distributed-computing/Apache-Spark/examples/spark-grain-placement' },
      { id: 9, key: 'Apache-Spark-grains', title:'Grain Versioning', slug:"", link: '/distributed-computing/Apache-Spark/examples/spark-grain-versioning' },
      { id: 7, key: 'Apache-Spark-observability', title:'Prometheus', slug:"", link: 'https://prometheus.io/' },
      { id: 8, key: 'Apache-Spark-observability', title:'Grafana', slug:"", link: 'https://grafana.com' },
      { id: 9, key: 'Apache-Spark-observability', title:'Spark Counters', slug:"", link: 'https://learn.Apache.com/en-us/dotnet/spark/host/monitoring/?pivots=Spark-7-0#messaging' },
      { id: 19, key: 'Apache-Spark-distributed-tracing', title:'Prometheus', slug:"", link: 'https://prometheus.io/' },
      { id: 11, key: 'Apache-Spark-distributed-tracing', title:'Grafana', slug:"", link: 'https://grafana.com' },
      { id: 12, key: 'Apache-Spark-distributed-tracing', title:'Zipkin', slug:"", link: 'https://zipkin.com' }
  ]

    suggestedCourses = [
        { id: 1, key: 'getting-started-with-Apache-Spark', title:'What is Apache Spark', slug:"What is Apache Spark", link: '/distributed-computing/spark/concepts' },
        { id: 2, key: 'how-do-distributed-frameworks-operate', title:'How do distributed-frameworks-operate?', slug:"how-do-distributed-frameworks-operate", link: '/distributed-computing/basics/' },
        { id: 3, key: 'how-do-distributed-frameworks-operate', title:'How do distributed-frameworks-operate?', slug:"how-do-distributed-frameworks-operate", link: '/distributed-computing/basics/' },
        { id: 4, key: 'Apache-Spark-concepts', title:'The Actor Model', slug:"", link: 'https://en.wikipedia.org/wiki/Actor_model' },
        { id: 5, key: 'Apache-Spark-concepts', title:'AKKA Framework', slug:"", link: 'https://akka.io/' },
        { id: 6, key: 'Apache-Spark-grains', title:'Grain Identity', slug:"", link: '/distributed-computing/Apache-Spark/examples/spark-grain-identity' },
        { id: 7, key: 'Apache-Spark-grains', title:'Grain Life Cycle', slug:"", link: '/distributed-computing/Apache-Spark/examples/spark-grain-lifecycle' },
        { id: 8, key: 'Apache-Spark-grains', title:'Grain Placement', slug:"", link: '/distributed-computing/Apache-Spark/examples/spark-grain-placement' },
        { id: 9, key: 'Apache-Spark-grains', title:'Grain Versioning', slug:"", link: '/distributed-computing/Apache-Spark/examples/spark-grain-versioning' },
        { id: 7, key: 'Apache-Spark-observability', title:'Prometheus', slug:"", link: 'https://prometheus.io/' },
        { id: 8, key: 'Apache-Spark-observability', title:'Grafana', slug:"", link: 'https://grafana.com' },
        { id: 9, key: 'Apache-Spark-observability', title:'Spark Counters', slug:"", link: 'https://learn.Apache.com/en-us/dotnet/spark/host/monitoring/?pivots=Spark-7-0#messaging' },
        { id: 19, key: 'Apache-Spark-distributed-tracing', title:'Prometheus', slug:"", link: 'https://prometheus.io/' },
        { id: 11, key: 'Apache-Spark-distributed-tracing', title:'Grafana', slug:"", link: 'https://grafana.com' },
        { id: 12, key: 'Apache-Spark-distributed-tracing', title:'Zipkin', slug:"", link: 'https://zipkin.com' }
    ]

    constructor(props) {
        super(props);
        this.state.slug = props.params.slug;
    }
    componentDidUpdate(prevProps, prevState, False) {
        console.log('SparkPage: Rebinding jquery hooks after document update');
        // console.log('MarkdownDisplay: component updating ' + this.state.html);

        // Connect Copy and Tag functionality
        attachCopyTagHandlers();

        $("div[data-mime-type='application/vnd.jupyter.stderr']").hide();

        setTimeout(() => Prism.highlightAll(), 0);
    }
  componentDidUnMount() {
    console.log('Spark Page component UNMOUNTED');
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
      console.log("Should update called with counter " + this.state.counter);
      //setTimeout(() => Prism.highlightAll(), 0);
      const ret = this.state.counter < 1;
      this.state.counter = this.state.counter + 1;
      console.log("Should update called with counter " + this.state.counter);
      return ret;
  }

        componentDidMount() {

    // Get the contents from the HTML file and put them in the React state, so we can reference it in render() below.
    const path = this.slugs.filter(path => path.slug === this.state.slug);
    console.log("OP Slug [" + this.state.slug + "] matched to url [" + path[0].source + "]" )

    if(path.length === 0){
      console.error('OP Failed to located path for : ' + this.state.slug);
      //this.setState((state) => ({ ...state, "Failed to located requested content" }));
    }

    const next = this.nextPage.filter(item => item.key === this.state.slug)[0];
    const related = this.relatedPages.filter(item => item.key === this.state.slug);
    const suggested = this.suggestedCourses.filter(item => item.key === this.state.slug);

    this.setState({
        nextContent : next !== undefined ? next : {key: '', slug: '', title:'Spark', path: '/distributed-computing/Apache-Spark/' },
        relatedContent : related,
        title : path[0].title,
        tags : path[0].tags,
        sourceLinks : path[0].sourceLinks,
        languages: path[0].languages,
        algos: path[0].algos,
        suggestedCourses: suggested,
        attributed: path[0].attributed

    });
      if(this.state){
          console.log("OP Next Page Value determined as : " + this.state.nextContent);
      }

     fetch(path[0].source)
      .then(res => res.text())
      .then(html => this.setState((state) => ({ ...state, html})))
      //.then(html => console.log(html))
      .catch((err) => console.error(err));
      console.log("OP Page content was successfully retrieved ");

    //console.log("OP MOUNTED There are [" + $(".wiki-preview").length + " ] wiki tags on the page");
    /*  attachCopyTagHandlers();

      Prism.highlightAll();*/

    console.log('SparkPage component mounted ' + this.state.html);
  }


  render() {

    return (
            <PageComponent props={this.state} page="Spark Page" />
            );

  }
}

export default withParams(SparkPage);